<div class="outside-container mt-4">
<div class="box-container ">
<div class="container">
<div class="title row">
<span *ngIf="screenSetting==='default'" class="row">
<div class=" col-md-4 d-flex justify-content-start "></div>  
<div class="col-md-8 d-flex justify-content-start">Gilpin Activity Control</div>
</span>
<span *ngIf="screenSetting==='activity'" class="row">
    <div class=" col-md-4 d-flex justify-content-start "><span (click)="backToMenu()"  class="pointer" >⬅️</span></div>  
    <div class="col-md-8 d-flex justify-content-start">Gilpin Activity Controls</div>
    </span>
<span *ngIf="screenSetting==='CTSetting'" class="row">
    <div class=" col-md-4 d-flex justify-content-start "><span (click)="backClick()" class="pointer" >⬅️</span></div>  
    <div class="col-md-8 d-flex justify-content-start">Color & Text Settings</div>
    </span>
    <span *ngIf="screenSetting==='imgSetting'" class="row">
        <div class=" col-md-4 d-flex justify-content-start "><span (click)="backClick()" class="pointer" >⬅️</span></div>  
        <div class="col-md-8 d-flex justify-content-start">Logo Settings</div>
        </span>
</div>

<div *ngIf="screenSetting==='default'" class="pt-3 d-flex justify-content-start colorblue" (click)="screenSettings('activity')" style="width: 260px; height: 40px;list-style-type:disc">Manage your Gilpin Screen Settings</div>

<span *ngIf="screenSetting==='activity'">
<div class="pt-3 d-flex justify-content-start colorblue" (click)="screenSettings('CTSetting')"  style="width: 155px; height: 40px;list-style-type:disc">Color & Text Settings</div>
<div class="pt-3 d-flex justify-content-start colorblue" (click)="screenSettings('imgSetting')" style="width: 112px; height: 40px;list-style-type:disc">Logo Settings</div>
</span>
<span *ngIf="screenSetting==='CTSetting'" >
    <app-color-text-settings></app-color-text-settings>
</span>
